export const reSetBar = ()=> {
    var topbar = document.getElementById("nprogress").querySelector(".bar");
    topbar.style.width="0px"
}